module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vk9aG4/tc-custom/9780795352089.jpg?1700290556404",
      "alt": "This image is the cover for the book Marquis of Lossie, The Cullen Collection"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Marquis of Lossie, The Cullen Collection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A gothic novel of romance, danger, and deception—the sequel to the acclaimed "), _c('i', [_vm._v("Malcolm")]), _vm._v(" from the 19th-century Scottish literary master.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This 1877 sequel to Malcolm begins where the first volume of the doublet left off, at Lossie House in Cullen’s fictionalized Portlossie. Soon thereafter Malcolm travels to London to rescue Florimel from the harmful influences of duplicitous friends who do not have her best interests in mind. Kidnapping her out of London, Malcolm’s and Florimel’s return to the north coast of Scotland brings to a stirring climax the divergent threads of mystery and intrigue woven through this triumphant literary tapestry. It is a classic Victorian romance, complete with rogues, inheritances, castles, and of course true love. Of "), _c('i', [_vm._v("The Marquis of Lossie")]), _vm._v(", Michael Phillips says, “Escaping a common pitfall of sequels not measuring up to the level of excellence of their predecessor, MacDonald crafts an equally engaging, and in some ways an even heightened dramatic crescendo to "), _c('i', [_vm._v("Malcolm")]), _vm._v("’s story. With the setting so altered, this is a spectacular creative achievement.”\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George MacDonald, Michael Phillips\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0